import React from 'react';


const CustomContentRenderer = ({ state = {}, onSelectedChanged = () => { } }) => {
  const { values = [] } = state;
  const selectedAmount = values.length;
  const hasSelected = selectedAmount !== 0;

  onSelectedChanged(hasSelected);

  const selectedAmountSpan = (hasSelected)
    ? <span className="cats-number">{values.length}</span>
    : null;

  return (
    <div style={{ cursor: 'pointer' }}>
      <span>Categories</span>
      {selectedAmountSpan}
    </div>
  );
};

export default CustomContentRenderer;
